import * as React from 'react'
import * as ReactDOM from 'react-dom'

interface IMapProps {
  onMapMounted?: (map: google.maps.Map) => void
}

interface IMapState {
  map: google.maps.Map | null
  center: google.maps.LatLng
  zoom: number
}

class Map extends React.Component<IMapProps, IMapState> {
  public drawingManager: any = null

  constructor(props: IMapProps) {
    super(props)
    this.state = {
      map: null,
      zoom: 8,
      center: new google.maps.LatLng(27.972572, -82.796745)
    }
  }

  public componentDidMount() {
    this.initMaps()
  }

  public render() {
    return <div style={{ height: '100%' }} />
  }

  private initMaps() {
    const div: any = ReactDOM.findDOMNode(this)
    const map = new google.maps.Map(div, {
      center: this.state.center,
      zoom: this.state.zoom,
      fullscreenControl: false,
      streetViewControl: false,
      mapTypeControl: false
    })
    this.setState({
      map
    })
    if (this.props.onMapMounted) {
      this.props.onMapMounted(map)
    }
  }
}

export default Map



// WEBPACK FOOTER //
// ./src/components/organizations/Map.tsx